module.exports = __webpack_public_path__ + "assets/img/workLeft2.0efbd756.png";